import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';

import { Router } from '@angular/router';
import { map, take, tap } from 'rxjs/operators';
import { AuthService } from '@app/services/auth.service';
import { Define } from '@app/models/define';

@Injectable({
  providedIn: 'root'
})
export class ReportGuard  {
  constructor(
    private router: Router,
    private auth: AuthService,
    private route: ActivatedRoute
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.auth.user.pipe(
      take(1),
      map(user =>
        (user?.manageAuthority !== undefined && user.manageAuthority >= Define.ManageAuthority.Maintener)
        || (user?.authority != null && user.authority >= Define.Authority.Approver)), // 権限が1以上のuserならtrueを返す
      tap(result => {
        if (!result) {
          this.router.navigate(['/home/history'], {relativeTo: this.route });
        }
      })
    );
  }
}
